// Core i18next library.
import i18n from "i18next";
// Bindings for React: allow components to
// re-render when language changes.
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";

export const supportedLngs = {
  en: "Eng",
  uk: "Укр",
  pl: "Pol",
  ro: "Rom",
  hr: "Cro",
};

const isServer = typeof window === "undefined";

// On the server we load translations synchronously from filesystem in `entry-server.tsx`.
// Enabling the HTTP backend here would make Node try to fetch relative URLs like
// `/locales/en/translation.json`, which leads to SSR noise and can affect hydration.
if (!isServer) {
  i18n.use(HttpApi);
}

i18n
  // Add React bindings as a plugin.
  .use(initReactI18next)
  // Initialize the i18next instance.
  .init({
    //lng: "en",
    fallbackLng: "en",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: [...Object.keys(supportedLngs), "hr", "el", "bg"],
    react: {
      // Avoid Suspense for translations: preloaded on SSR clone + client fetch before
      // hydrate; Suspense on client often contributes to hydration mismatches (#418).
      useSuspense: false,
    },
    // Translation messages. Add any languages
    // you want here.
    /*resources: {

    },*/
  });

export default i18n;
